import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../features/auth/authSlice";
import { setFaroUser, clearFaroUser } from "../services/faro";

const useFaroUser = () => {
  const user = useSelector(selectUser);

  useEffect(() => {
    if (user?.id) {
      setFaroUser(user);
    } else {
      clearFaroUser();
    }
  }, [user?.id, user?.email, user?.organisation?.id]);
};

export default useFaroUser;
